import { Component, OnInit, EventEmitter, Output, Input } from "@angular/core";
import { ExperiencesService } from "@services/experience/experiences.service";
import { ExperienceCountService } from "@services/experience/experience-count.service";
import { Counter } from "@models/counter";
import { TranslateService } from "@ngx-translate/core";
import { OidcSecurityService } from "angular-auth-oidc-client";

@Component({
  selector: "app-navigation",
  templateUrl: "./navigation.component.html",
  styleUrls: ["./navigation.component.scss"],
})
export class NavigationComponent implements OnInit {
  public dropdownNumber: number = 1;
  public isOpen = false;
  public innerWidth: number;
  public countExperience: any;
  public counter: Counter;
  @Input("mobileClicked")
  public mobileClicked: boolean;
  @Output() hideBackground = new EventEmitter<boolean>();

  constructor(
    public auth: OidcSecurityService,
    private experienceSvc: ExperiencesService,
    private experienceCountSvc: ExperienceCountService,
    private translate: TranslateService
  ) {
    this.experienceCountSvc.count.subscribe((data) => (this.counter = data));
  }

  ngOnInit() {
    this.innerWidth = window.innerWidth;

    if (1025 >= this.innerWidth) {
      this.mobileClicked = false;
    } else {
      this.mobileClicked = true;
    }
  }

  public toggle() {
    this.isOpen = !this.isOpen;
  }

  public backgroundClose() {
    if (this.innerWidth < 1025) {
      this.mobileClicked = !this.mobileClicked;
      this.hideBackground.emit(this.mobileClicked);
    }
  }

  public onResize(event) {
    this.innerWidth = window.innerWidth;

    if (1025 >= this.innerWidth) {
      this.mobileClicked = false;
    } else {
      this.mobileClicked = true;
    }
  }

  public openMenu(a) {
    if (this.dropdownNumber == a) {
      this.dropdownNumber = null;
      return;
    }
    this.dropdownNumber = a;
  }

  public useLanguage(language: string) {
    this.translate.use(language);
    localStorage.setItem("langForStrowBusiness", language);
  }

  public async logOut() {
    await this.auth.logoffAndRevokeTokens().toPromise();
  }
}
